/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IPageFooterData } from './page-footer.data';
import { IPageFooterProps } from './page-footer.props.autogenerated';
import * as Msdyn365 from '@msdyn365-commerce/core';

export interface IPageFooterViewProps extends IPageFooterProps<IPageFooterData> {
    title?: string;
    description?: Msdyn365.RichText;
    buttonText?: string;
    buttonLink?: Msdyn365.ILinkData;
    hide: boolean;
}

/**
 *
 * PageFooter component
 * @extends {React.PureComponent<IPageFooterProps<IPageFooterData>>}
 */
class PageFooter extends React.PureComponent<IPageFooterProps<IPageFooterData>> {
    public render(): JSX.Element | null {
        const { config } = this.props;
        const viewProps = {
            ...this.props,
            title: config.title ? config.title : '',
            description: config.description ? config.description : '',
            buttonText: config.buttonText ? config.buttonText : '',
            buttonLink: config.buttonLink ? config.buttonLink : '',
            hide: config.hide
        };
        return this.props.renderView(viewProps);
    }
}

export default PageFooter;
